import React from 'react';
import logo from '../assets/images/C_logo.png';
import add from '../assets/images/iosadd.svg';
import share from '../assets/images/iosshare.svg';
import plus from '../assets/images/iosplus.svg';

const AddHome = (props) => {

    const onConfirm = (e) => {
        localStorage.setItem("prompedHome", true)
        props.prompSwitcher()
    }

    return (
        <div className="prompt__root">
            <img className="img-fluid about__logo mb-4 mx-auto" alt="logo" src={logo}/>
            <span className="prompt__header">کارکلیک را به صفحه اصلی اضافه کنید</span>
            <span className="prompt__header--sub my-4">با این کار، می‌توانید برای همیشه و بدون نیاز به بروزرسانی از خدمات کارکلیک استفاده کنید.</span>
            <div className="prompt__bullet-container">
                <span className="prompt__bullet-text">۱- روی دکمه <span className="prompt__bullet-text--focus">Share</span> در نوار پایین کلیک کنید.</span>
                <img src={share}/>
            </div>
            <div className="prompt__bullet-container">
                <span className="prompt__bullet-text">۲- گزینه <span className="prompt__bullet-text--focus">Add To Home Screen</span> را فعال کنید.</span>
                <img src={plus}/>
            </div>
            <div className="prompt__bullet-container">
                <span className="prompt__bullet-text">۳- در قسمت بالا روی <span className="prompt__bullet-text--focus">Add</span> کلیک کنید.</span>
                <img src={add}/>
            </div>
            <button className="about__btn py-4" onClick={onConfirm}>متوجه شدم</button>
        </div>
    )
}

export default AddHome